/**
 * AI Inline System Types
 * Tipos para o sistema de IA inline no editor
 */

export interface AICommand {
  id: string;
  type: 'suggest' | 'refactor' | 'expand' | 'summarize' | 'tone';
  label: string;
  icon?: string;
  description?: string;
  requiresSelection?: boolean;
}

export interface AIRequest {
  command: string;
  content: string;
  selectedText?: string;
  context?: string;
  streaming?: boolean;
  options?: Record<string, any>;
}

export interface AIResponse {
  success: boolean;
  content: string;
  error?: string;
  streaming?: boolean;
}

export interface AIStreamChunk {
  type: 'start' | 'chunk' | 'complete' | 'error';
  content: string;
  error?: string;
}

export interface AIInlineState {
  isActive: boolean;
  isLoading: boolean;
  isStreaming: boolean;
  currentCommand: AICommand | null;
  selectedText: string;
  ghostText: string;
  menuVisible: boolean;
  tooltipVisible: boolean;
  error: string | null;
}

export interface AIMenuPosition {
  x: number;
  y: number;
  visible: boolean;
}

export interface AITooltipPosition {
  x: number;
  y: number;
  visible: boolean;
  selectedText: string;
}

export const AI_COMMANDS: AICommand[] = [
  {
    id: 'suggest',
    type: 'suggest',
    label: 'Sugerir conteúdo',
    icon: '✨',
    description: 'Gerar sugestões de conteúdo baseadas no contexto',
    requiresSelection: false,
  },
  {
    id: 'refactor',
    type: 'refactor',
    label: 'Refatorar texto',
    icon: '🔄',
    description: 'Melhorar e reorganizar o texto selecionado',
    requiresSelection: true,
  },
  {
    id: 'expand',
    type: 'expand',
    label: 'Expandir',
    icon: '📝',
    description: 'Expandir o texto com mais detalhes',
    requiresSelection: true,
  },
  {
    id: 'summarize',
    type: 'summarize',
    label: 'Resumir',
    icon: '📋',
    description: 'Criar um resumo do texto selecionado',
    requiresSelection: true,
  },
  {
    id: 'tone',
    type: 'tone',
    label: 'Ajustar tom',
    icon: '🎭',
    description: 'Ajustar o tom do texto (formal, informal, técnico)',
    requiresSelection: true,
  },
];